import './Blogs.css'
import { useNavigate } from "react-router-dom";
const Blogs = () => {
    return (
      <main>
      <section id="join">
      <h2>Be a Part of Us</h2>
      <p>EmpowerArt welcomes non-profit organizations, orphanages, disabled artists, and art enthusiasts to join us in our mission of creating an inclusive platform for artistic expression and empowerment.</p>
      <p>Organizations and individuals can become a part of EmpowerArt in several ways:</p>
      
        <p>Upload NFTs: Non-profit organizations, orphanages, and disabled artists can showcase their artwork by uploading NFTs to our platform. This allows them to gain visibility, connect with art enthusiasts, and contribute to their causes.</p>
        <p>Contribute to Causes: Art enthusiasts and supporters can directly contribute to the causes represented by the artists. By purchasing NFTs, individuals not only acquire unique artwork but also make a positive impact on the lives of the artists and support the organizations they represent.</p>
        <p>Collaborate and Connect: EmpowerArt fosters collaboration and connection among artists, organizations, and individuals. By joining our community, you can engage with like-minded individuals, share insights, and inspire each other.</p>
      
      <p>Together, let's celebrate the diversity of artistic expression and empower marginalized individuals to shine on the global stage.</p>
    </section>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSd2KquZWwNq1dIwF3XQNA513F3LenhBfoymqIugpfnteJEHsw/viewform?usp=sf_link"> <button onClick={()=>{
        }}> Link to Google Form</button></a>
    </main>);
  };

  export default Blogs;
